export default __webpack_public_path__ + "static/media/NeoNX110_Frente.fc9b52be.webp";